
<div >
    <div class="row " *ngIf="!clientEnable">
      <div class="col pl-3">
        <h4 class="mb-0 font-header-1 mb-2" style="font-weight: 700;" *ngIf="!clientedit">
          Care Coordinator </h4>
      </div>
    </div>
    <div *ngIf="global.globalAgencyId==null || global.globalAgencyId==undefined ||global.globalAgencyId=='00000000-0000-0000-0000-000000000000'|| global.globalAgencyId=='' ">
      <div class="row mt-4 ">
        <div class="col ">
          <div widget class="card border-0 box-shadow">
            <div class="card-body  widget-body pt-2">
              <div class="text-center text-danger">
                <label class="font-red animate-charcter"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency to
                  view
                  details</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-4"
      *ngIf="global.globalAgencyId!=null && global.globalAgencyId!='' && global.globalAgencyId!=undefined &&  global.globalAgencyId!='00000000-0000-0000-0000-000000000000'">
      <div class="col">
        <div widget class="card border-0 box-shadow">
          <div class= "card-body widget-body pt-2">
            <div class="row mt-2">
              <div class="ml-auto mr-4">
                <button type="button" class="btn btn-primary btn-sm text-right mb-1" [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'" data-bs-toggle="modal" data-bs-target="#exportascsvmodel">
                  Export as CSV
                </button>
              </div>
            </div>
            <div class="row" *ngIf="!clientEnable">
              <div class="col-lg-4">
                <div class="col-lg-12">
                  <label style="font-weight:bold">Filter By </label>
                </div>
                <div class="col-lg-12">
                  <select [(ngModel)]="SearchColumn" class="form-control " (ngModelChange)="setDefaultValue()"
                    [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'">
                    <option *ngFor="let item of filterItems | keyvalue" [ngValue]="item"> {{item.value}}</option>
                  </select>
                </div>
              </div>
              <div class="col-lg-4" *ngIf="SearchColumn.key!=''">
                <div class="col-lg-12">
                  <label style="font-weight:bold">{{SearchColumn.value}}</label>
                </div>
                <div class="col-lg-12">
                  <input (keydown)="onKeydown($event)" type="text" class="form-control  ml-1" [(ngModel)]="SearchText"
                    [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'" />
                </div>
              </div>
              <!-- Apply  -->
              <div class="col-lg-4 ">
                <div class="col-lg-12 mt-2">
                  <label></label>
                </div>
                <div class="col-lg-12">
  
                  <button type="button" class="btn blue-btn btn-sm" (click)="Search()"
                    [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'">
                    Apply
                  </button>
                </div>
              </div>
            </div>
            <div class="row  mb-2 mt-2  pl-3 pr-3" *ngIf="!clientEnable">
              <!-- Add Case Coordinator  -->
              <div class="col-lg-8">
                <button type="button" class="btn blue-btn btn-sm" data-bs-toggle="modal" data-bs-target="#modal"
                  [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'" *ngIf="fp.carecoordinatorcreate"
                  (click)="CareCreateupdate('new')">Add
                  Care Coordinator</button>
              </div>
              <!-- Refresh  -->
              <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12 " *ngIf="!clientedit">
                <button type="button" class="btn blue-btn btn-sm " style="float:right" (click)="Refresh()"
                  [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'">
                  <i class="fa fa-repeat"> Refresh </i>
                </button>
              </div>
            </div>
            <div class="row pl-3 pr-3">
              <div class="col-lg-12 ">
                <ejs-grid #grid [dataSource]='data | async' [allowResizing]='true' queryCellInfo='customiseCell($event)'
                  *ngIf="global.globalAgencyId!=0" [allowSorting]='true' allowPaging='true' [allowFiltering]='true'
                  (resizeStop)="onResize($event)" [pageSettings]='initialPage' [filterSettings]='filterSettings'
                  (dataStateChange)='dataStateChange($event)' (actionBegin)="onActionComplete($event)"
                  [showColumnChooser]='true'>
                  <e-columns>
                    <e-column field="action" uid="action" textAlign="center" [allowFiltering]='false'
                      [showInColumnChooser]='false' minWidth=100>
                      <ng-template #template let-data *ngIf="!clientEnable">
                        <button class="btn btn-edit-table" data-bs-toggle="modal" *ngIf="fp.carecoordinatorupdate"
                          data-bs-target="#modal" 
                          (click)="CareCreateupdate('edit');selectCaredetails(data)"><i
                            class="fa fa-edit"></i></button>&nbsp;
                        <button class="btn btn-delete-table" *ngIf="fp.carecoordinatordelete" data-bs-toggle="modal"
                          data-bs-target="#deletemodal" (click)="selectCaredetails(data)"><i
                            class="fa fa-trash"></i></button>
                      </ng-template>
                      <ng-template #template let-data *ngIf="clientEnable">
                        <input type="radio" (change)="carecodeemit(data)">
                      </ng-template>
                    </e-column>
                    <e-column field="coordinator_Name" headerText="Name" minWidth=100 type="string">
                      <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                      </ng-template>
                    </e-column>
                    <e-column field="county" headerText="County" minWidth=100 type="string">
                      <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                      </ng-template>
                    </e-column>
                    <e-column field="phoneNumber" headerText="PhoneNumber" minWidth=100 type="string">
                      <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                      </ng-template>
                    </e-column>
                    <e-column field="fax" headerText="Fax" type="string" minWidth=100>
                      <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                      </ng-template>
                    </e-column>
                    <e-column field="alternateFax" headerText="Alternative Fax" type="string" minWidth=100>
                      <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                      </ng-template>
                    </e-column>
                    <e-column field="email" headerText="Email" type="string" minWidth=100>
                      <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                      </ng-template>
                    </e-column>
  
                    <!--------------------------------table header icon---------------->
                    <e-column width="50" [showInColumnChooser]='false'>
                      <ng-template #headerTemplate let-data>
                        <div class="d-none d-lg-block">
                          <span id='show' (click)='show()'><i class="fa fa-cog fa-lg" aria-hidden="true"> </i></span>
                        </div>
                      </ng-template>
                    </e-column>
                  </e-columns>
                </ejs-grid>
              </div>
            </div>
            <div *ngIf="CareDatalist.length == 0  &&  global.globalAgencyId!=0" class="text-center" style="color:red">
              <p>No data available</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- ///////////////////////////////////////////////////// -->
  <span id="openModal1" data-bs-target="#modal" data-bs-toggle="modal"></span>
  <div class="modal fade modalbackgrod" id="modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog create-update-zip" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-header" id="exampleModalLabel">
            <span *ngIf="ModelType =='new'"> Create Care Coordinator</span>
               <span *ngIf="ModelType =='edit'">Update Care Coordinator</span> </h5>

          <button type="button" class="btn-close" (click)="dismissModal()" aria-label="Close">
            <span aria-hidden="true"></span>
          </button>
  
        </div>
        <div class="modal-body">
          <form [formGroup]="CareForm">
            <div class="row">
              <div class="col-lg-5">
                <label>Name <sup class="super-script">&nbsp; *</sup>
                </label>
              </div>
              <div class="col-lg-7">
                <input type="text" class="form-control" formControlName="Coordinator_Name"
                  [(ngModel)]="Care.coordinator_Name" name="Coordinator_Name"
                  (ngModelChange)="checkpopup('Name')" />
              </div>
            </div>
            <span class="help-block text-danger text-center"
              *ngIf="!CareForm.get('Coordinator_Name').valid && CareForm.get('Coordinator_Name').touched ">
              <p>Please Enter Name</p>
            </span>
            <div class="row">
              <div class="col-lg-5">
                <label>County</label>
              </div>
              <div class="col-lg-7">
                <input type="text" class="form-control" formControlName="County" [(ngModel)]="Care.county" name="county"
                  (ngModelChange)="checkpopup('County')">
              </div>
            </div>
  
            <div class="row">
              <div class="col-lg-5">
                <label>PhoneNumber</label>
              </div>
              <div class="col-lg-7">
                <input type="text" min="0" max="99999999999999" maxlength="14" class="form-control"
                  (keypress)="numberOnly($event)" formControlName="PhoneNumber" ng-pattern="^(\+\d{1,3}[- ]?)?\d{10}$"
                  [(ngModel)]="Care.phoneNumber" (ngModelChange)="DemographicPhoneFormat();checkpopup('PhoneNumber')"
                  name="PhoneNumber" />
              </div>
            </div>
  
  
            <div class="row">
              <div class="col-lg-5">
                <label>Fax</label>
              </div>
              <div class="col-lg-7">
                <input type="text" min="0" max="99999999999999" maxlength="14" class="form-control"
                  (keypress)="numberOnly($event)" formControlName="Fax" [(ngModel)]="Care.fax"
                  (ngModelChange)="DemographicPhoneFormat1();checkpopup('Fax')" name="Fax" />
              </div>
            </div>
  
  
            <div class="row">
              <div class="col-lg-5">
                <label>Alternate Fax</label>
              </div>
              <div class="col-lg-7">
                <input type="text" min="0" max="99999999999999" maxlength="14" class="form-control"
                  formControlName="AlternateFax" [(ngModel)]="Care.alternateFax" (keypress)="numberOnly($event)"
                  (ngModelChange)="DemographicPhoneFormat2();checkpopup('AlternateFax')" name="AlternateFax" />
              </div>
            </div>
  
            <div class="row">
              <div class="col-lg-5">
                <label>Email</label>
              </div>
              <div class="col-lg-7">
                <input type="text" class="form-control" formControlName="Email" [(ngModel)]="Care.email" name="Email"
                  (ngModelChange)="checkpopup('Email')" (keypress)="global.preventforSpace($event)" />
              </div>
            </div>
  
            <div class="row">
            
              <div class="col-lg-12 col-md-12 d-inline-flex">
                <label class="mr-1 label-bold  w-50"></label>
                <span *ngIf="checkEmailValidation" style="color:red
                ">Please enter valid email</span>
  
              </div>
            </div>
  
          </form>
        </div>
        <div class="modal-footer">
          <button class="btn blue-btn btn-sm" (click)="SaveOrUpdateCare();" [disabled]="!CareForm.valid"><span
              *ngIf="ModelType =='new'"> Save &
              Close</span> <span *ngIf="ModelType =='edit'">Update & Close</span> </button>
          <button type="button" class="btn blue-btn btn-sm" (click)="openDialog()">Close</button>
        </div>
      </div>
    </div>
  </div>
  
  <span id="openModal2" data-bs-target="#deletemodal" data-bs-toggle="modal"></span>
  <div class="modal fade" id="deletemodal" data-bs-backdrop="static">
    <div class="modal-dialog delete-zip" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-header">Delete Record</h5>
          <button type="button" class="btn-close" (click)="closecarecoordinator()" aria-label="Close">
            <span aria-hidden="true"></span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-12">
              <label>Do you want to delete this record ?</label>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn blue-btn btn-sm" (click)="deleteCare()">Delete</button>
          <button type="button" class="btn blue-btn btn-sm" (click)="closecarecoordinator()">Cancel</button>
        </div>
      </div>
    </div>
  </div>
  
  <!-- ==============close without save modal================================= -->
  <span id="cancelcarecomodal" data-bs-toggle="modal" data-bs-target="#ClosecarecoModal"></span>
  <div class="modal fade primarymodal alertmodel modalbackgrod" id="ClosecarecoModal" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog create-update-zip " role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-header" id="exampleModalLabel">Close</h5>
          <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true"></span>
          </button>
        </div>
        <div class="modal-body">
          You want to close without save?
        </div>
        <div class="modal-footer">
          <button type="button" class="btn blue-btn btn-sm" (click)="closeAddUpdateModal()">Yes</button>
          <button type="button" class="btn blue-btn btn-sm" (click)="closealertmodal()">No</button>
        </div>
      </div>
    </div>
  </div>
  
  
  
  
  <!-- exportascsvmodel -->
  
  <span id="exportascsv" data-bs-toggle="modal" data-bs-target="#exportascsvmodel"></span>
  <div class="modal fade" id="exportascsvmodel" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog modal-md" role="document">
          <div class="modal-content">
              <div class="modal-header">
                  <h5 class="modal-title font-header">Export as CSV</h5>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                      
                  </button>
              </div>
              <div class="modal-body">
                  <div class="row">
                      <div class="col-lg-6">
                          <button class="btn blue-btn btn-sm mb-1" (click)="exportCaseWithPaginationCsv()">
                              Print Current page
                          </button>
                      </div>
                      <div class="col-lg-6">
                          <button class="btn blue-btn btn-sm mb-1" (click)="exportCaseCsv()">
                              Print All page
                          </button>
                      </div>
                  </div>
              </div>
              <div class="modal-footer">
                  <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">
                      Close
                  </button>
              </div>
          </div>
      </div>
  </div>